import { Injectable } from '@angular/core';
import { CoreEnum } from '../enums/core.enum';

@Injectable({
  providedIn: 'root'
})
export class TranslateEnumService {

  // DEBUG
  readonly UNKNOWN = 'N/A';
  // CoilState
  readonly COIL_STATE_UNSTARTED = 'Non commencé';
  readonly COIL_STATE_PROGRAMMED = 'Programmé';
  readonly COIL_STATE_IDENTIFIED = 'Identifié';
  readonly COIL_STATE_IN_PROGRESS = 'En cours';
  readonly COIL_STATE_COMPLETED = 'Terminé';
  // mountingState
  readonly MOUNTING_STATE_COMPLETED = 'Terminé';
  readonly MOUNTING_STATE_IN_PROGRESS = 'En cours';
  readonly MOUNTING_STATE_UNSTARTED = 'Non commencé';
  // mountingState
  readonly OPERATION_TYPE_LMX = 'LMX';
  readonly OPERATION_TYPE_VER = 'VER';
  readonly OPERATION_TYPE_REF = 'REF';
  // criticality of defect
  readonly DEFECT_CRITICALITY_LEVEL_1 = '1';
  readonly DEFECT_CRITICALITY_LEVEL_2 = '2';
  readonly DEFECT_CRITICALITY_LEVEL_3 = '3';
  readonly DEFECT_CRITICALITY_LEVEL_4 = '4';
  // role type
  readonly ROLE_TYPE_ADMINISTRATOR = 'Administrateur';
  readonly ROLE_TYPE_PROD_MANAGER = 'Responsable de production';
  readonly ROLE_TYPE_OPERATOR = 'Opérateur';
  readonly ROLE_TYPE_WAITING_PROFIL = 'En attente';
  readonly ROLE_TYPE_CONSULTATION = 'Consultation';
  // coil unwind position
  readonly COIL_UNWIND_POSITION_ABOVE = 'Dessus';
  readonly COIL_UNWIND_POSITION_BELOW = 'Dessous';
  // table ref
  readonly TABLE_REF_ACCOUNT = 'Compte';
  readonly TABLE_REF_CAUSE = 'Cause';
  readonly TABLE_REF_CHECKLIST = 'Checklist';
  readonly TABLE_REF_CODE_ALYZE = 'Coode alyze';
  readonly TABLE_REF_CODE_STOP = 'Code stop';
  readonly TABLE_REF_CODE_MBDB = 'Code MBDB';
  readonly TABLE_REF_COIL = 'Bobine';
  readonly TABLE_REF_COIL_DEFECT = 'Défaut';
  readonly TABLE_REF_COIL_CYCLE = 'Cycle';
  // production state
  readonly PRODUCTION_STATE_IN_PROGRESS = 'En cours';
  readonly PRODUCTION_STATE_LACK_OPERATORS = 'Manque Opérateur';
  readonly PRODUCTION_STATE_STOPPED_BY_USER = 'Arrêt par utilisateur';
  readonly PRODUCTION_STATE_WAITING = 'En attente';
  // view mode
  readonly VIEW_MODE_FULL = 'Tous droits';
  readonly VIEW_MODE_READ = 'Consultation';
  // view mode
  readonly STOP_TYPE_PLANNED = 'Planifié';
  readonly STOP_TYPE_NOT_PLANNED = 'Non planifié';
  // error messsage bakcned
  readonly EM_CLIENT_STOP_CONFLICT_CREATE = 'Conflit. Un arrêt existe déjà dans cette plage de date';
  readonly EM_CLIENT_STOP_CONFLICT_EDIT = 'Conflit. Un arrêt existe déjà dans cette plage de date';
  readonly EM_CLIENT_STOP_CONFLICT_SPLIT = 'Conflit. Scindage de l\'arrêts en conflits. Les arrêts ajoutés ne peuvent être sur une même plage de date';
  readonly EM_SERVER_INTERNAL = 'Erreur interne';
  // defect side
  readonly DEFECT_SIDE_UPPER = 'Dessus';
  readonly DEFECT_SIDE_LOWER = 'Dessous';
  readonly DEFECT_SIDE_BOTH = 'Les deux';

  constructor() {

  }

  getUnknown(): string {
    return this.UNKNOWN;
  }

  // getCoilState(coilState: CoilState): string {
  //   switch (coilState) {
  //     case CoilState.UNSTARTED:
  //       return this.COIL_STATE_UNSTARTED;
  //       case CoilState.PROGRAMMED:
  //         return this.COIL_STATE_PROGRAMMED;
  //     case CoilState.IN_PROGRESS:
  //       return this.COIL_STATE_IN_PROGRESS;
  //     case CoilState.COMPLETED:
  //       return this.COIL_STATE_COMPLETED;
  //     case CoilState.IDENTIFIED:
  //       return this.COIL_STATE_IDENTIFIED;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getMountingState(mountingState: MountingState): string {
  //   switch (mountingState) {
  //     case MountingState.COMPLETED:
  //       return this.MOUNTING_STATE_COMPLETED;
  //     case MountingState.IN_PROGRESS:
  //       return this.MOUNTING_STATE_IN_PROGRESS;
  //     case MountingState.UNSTARTED:
  //       return this.MOUNTING_STATE_UNSTARTED;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getOperationType(operationType: OperationType): string {
  //   switch (operationType) {
  //     case OperationType.LMX:
  //       return this.OPERATION_TYPE_LMX;
  //     case OperationType.REF:
  //       return this.OPERATION_TYPE_REF;
  //     case OperationType.VER:
  //       return this.OPERATION_TYPE_VER;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getCriticality(criticality: CRITICALITY_LEVEL): string {
  //   switch (criticality) {
  //     case CRITICALITY_LEVEL.LEVEL_1:
  //       return this.DEFECT_CRITICALITY_LEVEL_1;
  //     case CRITICALITY_LEVEL.LEVEL_2:
  //       return this.DEFECT_CRITICALITY_LEVEL_2;
  //     case CRITICALITY_LEVEL.LEVEL_3:
  //       return this.DEFECT_CRITICALITY_LEVEL_3;
  //     case CRITICALITY_LEVEL.LEVEL_4:
  //       return this.DEFECT_CRITICALITY_LEVEL_4;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  getDisplayNameBoolean(value: boolean): string {
    if (value) {
      return CoreEnum.TEXT_YES;
    } else {
      return CoreEnum.TEXT_NO;
    }
  }

  // getCoilUnwindPosition(coilUnwindPosition: CoilUnwindPosition): string {
  //   switch (coilUnwindPosition) {
  //     case CoilUnwindPosition.ABOVE:
  //       return this.COIL_UNWIND_POSITION_ABOVE;
  //     case CoilUnwindPosition.BELOW:
  //       return this.COIL_UNWIND_POSITION_BELOW;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getDefaultSelectOption(): string {
  //   return CoreEnum.TEXT_CHOICE;
  // }

  // getRole(role: RoleType): string {
  //   switch (role) {
  //     case RoleType.ADMINISTRATOR:
  //       return this.ROLE_TYPE_ADMINISTRATOR;
  //     case RoleType.PROD_MANAGER:
  //       return this.ROLE_TYPE_PROD_MANAGER;
  //     case RoleType.OPERATOR:
  //       return this.ROLE_TYPE_OPERATOR;
  //     case RoleType.WAITING_PROFIL:
  //       return this.ROLE_TYPE_WAITING_PROFIL;
  //     case RoleType.CONSULTATION:
  //       return this.ROLE_TYPE_CONSULTATION;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getTableRef(tableRef: TableRef): string {
  //   switch (tableRef) {
  //     case TableRef.ACCOUNT:
  //       return this.TABLE_REF_ACCOUNT;
  //     case TableRef.CAUSE:
  //       return this.TABLE_REF_CAUSE;
  //     case TableRef.CHECKLIST:
  //       return this.TABLE_REF_CHECKLIST;
  //     case TableRef.CODE_ALYZE:
  //       return this.TABLE_REF_CODE_ALYZE;
  //     case TableRef.CODE_MBDB:
  //       return this.TABLE_REF_CODE_MBDB;
  //     case TableRef.CODE_STOP:
  //       return this.TABLE_REF_CODE_STOP;
  //     case TableRef.COIL:
  //       return this.TABLE_REF_COIL;
  //     case TableRef.COIL_DEFECT:
  //       return this.TABLE_REF_COIL_DEFECT;
  //     case TableRef.CYCLE:
  //       return this.TABLE_REF_COIL_CYCLE;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getProductionState(state: ProductionState): string {
  //   switch (state) {
  //     case ProductionState.IN_PROGESS:
  //       return this.PRODUCTION_STATE_IN_PROGRESS;
  //     case ProductionState.LACK_OPERATORS:
  //         return this.PRODUCTION_STATE_LACK_OPERATORS;
  //     case ProductionState.STOPPED_BY_USER:
  //       return this.PRODUCTION_STATE_STOPPED_BY_USER;
  //     case ProductionState.WAITING:
  //       return this.PRODUCTION_STATE_WAITING;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getViewMode(viewMode: ViewModeType): string {
  //   switch (viewMode) {
  //     case ViewModeType.FULL:
  //       return this.VIEW_MODE_FULL;
  //     case ViewModeType.READ:
  //         return this.VIEW_MODE_READ;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getStopType(stopType: StopType): string {
  //   switch (stopType) {
  //     case StopType.NOT_PLANNED:
  //       return this.STOP_TYPE_NOT_PLANNED;
  //     case StopType.PLANNED:
  //         return this.STOP_TYPE_PLANNED;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getErrorMessageBackend(errorCodeMsg: ErrorCodeMsg): string {
  //   switch (errorCodeMsg) {
  //     case ErrorCodeMsg.CLIENT_STOP_CONFLICT_CREATE:
  //       return this.EM_CLIENT_STOP_CONFLICT_CREATE;
  //     case ErrorCodeMsg.CLIENT_STOP_CONFLICT_EDIT:
  //       return this.EM_CLIENT_STOP_CONFLICT_EDIT;
  //     case ErrorCodeMsg.CLIENT_STOP_CONFLICT_SPLIT:
  //         return this.EM_CLIENT_STOP_CONFLICT_SPLIT;
  //     case ErrorCodeMsg.SERVER_INTERNAL:
  //         return this.EM_SERVER_INTERNAL;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }

  // getDefectSide(defectSide: DefectSide): string {
  //   switch (defectSide) {
  //     case DefectSide.UPPER:
  //       return this.DEFECT_SIDE_UPPER;
  //     case DefectSide.LOWER:
  //       return this.DEFECT_SIDE_LOWER;
  //     case DefectSide.BOTH:
  //         return this.DEFECT_SIDE_BOTH;
  //     default:
  //       return this.UNKNOWN;
  //   }
  // }
}
